module.exports = __webpack_public_path__ + "img/no-icon.2ab3c945.svg";